//MR: This may be deprecated
import URLUtil from "../util/URLUtil";

var AccountDetailsFactory = function ($resource, $window, $http, $q) {
    const isLocalhost = () => String(window.location.href).indexOf("localhost") > -1;
    const useMock = () => URLUtil.getURLParam("useMocks") === "true";

    var baseAcctUrl =
        (isLocalhost() || useMock()) && window.location.port === "3001"
            ? $window.location.origin + $window.location.pathname
            : __baseApiUrl__;
    var accountDetailsApi =
        (isLocalhost() || useMock()) && window.location.port === "3001"
            ? "assets/data/get-account-details.json"
            : "/participant-web-services/rest/accounts/account/:individualId/:groupId";
    var summaryApi =
        "/participant-web-services/rest/accounts/account/details/:individualId/:groupId/summary";
    var rateOfReturnApi =
        "/participant-web-services/rest/accounts/account/rateofreturn/:groupId/startdate/:startDate/endDate/:endDate";
    var getComputerShareSamlTokenApi =
        "/computerShareSaml/individualId/:individualId/groupId/:groupId";
    var providerUrlAndPhoneNumberApi =
        "/participant-web-services/rest/accounts/:individualId/:groupId/getProviderUrlAndPhoneNumber";
    var isGroupAccountServiceExistApi =
        "/participant-web-services/rest/accounts/:individualId/:groupId/:sdsvCode/:sdsvSubcode/isGroupAccountServiceExist";
    var primaryPlanByIndId =
        "/participant-web-services/rest/accounts/primaryPlanByIndId/:individualId/:dbName?accuCode=:accuCode";
    var updateDefaultUrl =
        "/participant-web-services/rest/partialauth/oneId/refreshSessionWithContextSwitch/:individualId/:dbName/:accuCode/:updateDefault?gaId=:gaId";

    var accountDetailsParams =
        (isLocalhost() || useMock()) && window.location.port === "3001"
            ? {}
            : {
                  individualId: "@individualId",
                  groupId: "@groupId",
                  dbName: "@dbName"
              };
    var rateOfReturnParams = {
        groupId: "@groupId",
        startDate: "@startDate",
        endDate: "@endDate"
    };

    var computerShareSamlTokenParams = {
        individualId: "@individualId",
        groupId: "@groupId"
    };

    var providerUrlAndPhoneNumberParams = {
        individualId: "@individualId",
        groupId: "@groupId"
    };
    var isGroupAccountServiceExistParams = {
        individualId: "@individualId",
        groupId: "@groupId",
        sdsvCode: "@sdsvCode",
        sdsvSubcode: "@sdsvSubcode"
    };
    var primaryPlanByIndIdParams = {
        individualId: "@individualId",
        dbName: "@dbName",
        accuCode: "@accuCode"
    };
    var updateDefaultParams = {
        individualId: "@individualId",
        dbName: "@dbName",
        accuCode: "@accuCode",
        updateDefault: "@updateDefault",
        gaId: "@gaId"
    };

    /**
     * Indicates if the API should use credentials. Mock URLs should not.
     *
     * @param {String} url - The URL under inspection.
     * @param {String} [mockKey='mulesoft'] - The key to a mock URL.
     * @return {Boolean}
     */
    var getEnglishBaseApiUrl = function () {
        var https = "https://";
        var http = "http://";
        var period = ".";
        var newBaseApiUrl = __baseApiUrl__;
        var toLangCode = "es";
        if (
            __baseApiUrl__.indexOf(https + toLangCode) >= 0 ||
            __baseApiUrl__.indexOf(http + toLangCode) >= 0
        ) {
            newBaseApiUrl = newBaseApiUrl.replace(https + toLangCode + period, https);
            newBaseApiUrl = newBaseApiUrl.replace(http + toLangCode + period, http);
        }
        if (
            newBaseApiUrl === "" ||
            newBaseApiUrl.indexOf(https + toLangCode) >= 0 ||
            newBaseApiUrl.indexOf(http + toLangCode) >= 0
        ) {
            if (!$window.location.origin) {
                $window.location.origin =
                    $window.location.protocol +
                    "//" +
                    $window.location.hostname +
                    ($window.location.port ? ":" + $window.location.port : "");
            }
            var newBaseApiUrl = $window.location.origin;
            if (
                newBaseApiUrl.indexOf(https + toLangCode) >= 0 ||
                newBaseApiUrl.indexOf(http + toLangCode) >= 0
            ) {
                newBaseApiUrl = newBaseApiUrl.replace(https + toLangCode + period, https);
                newBaseApiUrl = newBaseApiUrl.replace(http + toLangCode + period, http);
            }
        }
        return newBaseApiUrl;
    };

    return {
        getBankAccounts: function (params) {
            var deferred = $q.defer();
            var usageType = params.usageType ? params.usageType : "ACHOUT";
            $http
                .get(
                    __baseApiUrl__ +
                        "/participant-web-services/rest/partBankAccount/getBankAccounts?gaId=" +
                        params.groupId +
                        "&indId=" +
                        params.individualId +
                        "&usageType=" +
                        usageType +
                        "&active=true"
                )
                .success(function (data, status, headers, config) {
                    deferred.resolve(data);
                })
                .error(function (data, status, headers, config, statusText) {
                    deferred.reject();
                });

            return deferred.promise;
        },

        accountDetails: $resource(baseAcctUrl + accountDetailsApi, accountDetailsParams, {
            query: {
                method: "GET",
                isArray: false
            }
        }),

        getSummary: $resource(__baseApiUrl__ + summaryApi, accountDetailsParams, {
            query: {
                method: "GET",
                isArray: false
            }
        }),

        getRateOfReturn: $resource(__baseApiUrl__ + rateOfReturnApi, rateOfReturnParams, {
            query: {
                method: "GET",
                isArray: false
            }
        }),

        getComputerShareSamlToken: $resource(
            __baseApiUrl__ + getComputerShareSamlTokenApi,
            computerShareSamlTokenParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        getProviderUrlAndPhoneNumber: $resource(
            __baseApiUrl__ + providerUrlAndPhoneNumberApi,
            providerUrlAndPhoneNumberParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        isGroupAccountServiceExist: $resource(
            __baseApiUrl__ + isGroupAccountServiceExistApi,
            isGroupAccountServiceExistParams,
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),
        primaryPlanByIndId: $resource(
            __baseApiUrl__ + primaryPlanByIndId,
            primaryPlanByIndIdParams,
            {
                query: {
                    method: "GET",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        ),
        updateDefaultPlan: $resource(__baseApiUrl__ + updateDefaultUrl, updateDefaultParams, {
            query: {
                method: "GET",
                isArray: false,
                headers: {
                    "Content-Type": "application/json"
                }
            }
        }),
        updateEngDefaultPlan: $resource(
            getEnglishBaseApiUrl() + updateDefaultUrl,
            updateDefaultParams,
            {
                query: {
                    method: "GET",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        )
    };
};

AccountDetailsFactory.$inject = ["$resource", "$window", "$http", "$q"];
export default AccountDetailsFactory;
